import type { ManagedUploadFile } from '@/features/files/types/attachment.ts'

export function getFileId(file: ManagedUploadFile) {
  return file.fileId ?? file.response?.id
}
